import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader/SectionHeader';
import { MaxLengths } from 'constants/forms';
import { FIELDS } from 'features/views/productionNew/form';

const Client = ({ isClosed }) => {
	const formData = useFormData();

	return (
		<Stack spacing={1}>
			<SectionHeader text={getLabelMessage('producedProductionNew:clientTitle')} variant="h5" />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						<Grid size={3}>
							<TextField
								size="small"
								fieldName={FIELDS.businessName}
								label={getLabelMessage('producedProductionNew:businessName')}
								disabled={isClosed}
								required={isNilOrEmpty(formData?.firstName) && isNilOrEmpty(formData?.surname)}
								validationDisplay={!formData?.businessName ? validationDisplayTypes.HIDDEN : undefined}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.BUSINESS_NAME,
									},
								}}
							/>
						</Grid>
						<Grid size={3}>
							<TextField
								size="small"
								fieldName={FIELDS.firstName}
								label={getLabelMessage('producedProductionNew:firstName')}
								disabled={isClosed}
								required={isNilOrEmpty(formData?.businessName)}
								validationDisplay={!formData?.firstName ? validationDisplayTypes.HIDDEN : undefined}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.NAME,
									},
								}}
							/>
						</Grid>
						<Grid size={3}>
							<TextField
								size="small"
								fieldName={FIELDS.surname}
								label={getLabelMessage('producedProductionNew:surname')}
								disabled={isClosed}
								required={isNilOrEmpty(formData?.businessName)}
								validationDisplay={!formData?.surname ? validationDisplayTypes.HIDDEN : undefined}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.SURNAME,
									},
								}}
							/>
						</Grid>
						<Grid size={3}>
							<TextField
								size="small"
								fieldName={FIELDS.personIn}
								label={getLabelMessage('producedProductionNew:personIn')}
								disabled={isClosed}
								required={formData?.documentType === 'B'}
								validationDisplay={!formData?.personIn ? validationDisplayTypes.HIDDEN : undefined}
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.PERSON_IN,
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	);
};

Client.propTypes = {
	isClosed: PropTypes.bool,
};

export default Client;
